import { useMemo } from 'react';

import { isLoading } from '#src/app/shared/utils/async';

import { useGeolocationEnabled } from '../useGeolocationEnabled';
import type { GeolocationValuesState } from '../useGeolocationNormalizedValues';
import { useGeolocationNormalizedValues } from '../useGeolocationNormalizedValues';

export function useGeolocationValues(): GeolocationValuesState {
	const geolocState = useGeolocationNormalizedValues();
	const geolocEnabledState = useGeolocationEnabled();

	const loadingState = useMemo(() => ({ status: 'loading' as const }), []);
	const emptyState = useMemo(() => ({ status: 'loaded' as const, values: undefined }), []);

	return useMemo(() => {
		if (isLoading(geolocEnabledState)) {
			return loadingState;
		}

		if (!geolocEnabledState.enabled) {
			return emptyState;
		}

		if (isLoading(geolocState)) {
			return loadingState;
		}

		return geolocState;
	}, [geolocState, geolocEnabledState, loadingState, emptyState]);
}
